export default __webpack_public_path__ + "static/media/100_15574.1b0dba05.jpg";